import React, { useEffect, useRef, useState } from 'react';
import styles from './ForgotPassword.module.css';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../common/loader/Loader';
import { AppDispatch, IRootState } from '../../../redux/rootReducer';
import { forgotPassword, resetValidationMessage } from '../../../redux/auth/actions/forgotPassword.action';

const ForgotPassword = () => {
    const dispatch: AppDispatch = useDispatch();
    const navigate: NavigateFunction = useNavigate();

    const [forgotDetails, setForgotDetails] = useState({
        email: '',
    });
    const [unvalid, setValidation] = useState(false);
    const emailRef = useRef<HTMLInputElement>(null);

    const loading = useSelector((state: IRootState) => state.forgotPassword.loading);
    const data = useSelector((state: IRootState) => state.forgotPassword.data);

    // remove extra spaces at starting, ending and in between the input value
    const removeExtraSpace = (value: string) => value.trim().split(/ +/).join("");

    const handleForgotDetails = (event: React.FormEvent<HTMLInputElement>) => {
        dispatch(resetValidationMessage());
        setForgotDetails({
            ...forgotDetails,
            [(event.target as HTMLInputElement).name]: removeExtraSpace((event.target as HTMLInputElement).value),
        });
    };

    const handleFotgotPassword = (e: React.FormEvent) => {
        e.preventDefault();
        if (forgotDetails.email.length === 0) {
            setValidation(true);
            emailRef.current?.focus();
            return;
        } else {
            unvalid && setValidation(false);
            dispatch(forgotPassword(forgotDetails));
        }
    };

    useEffect(() => {
        dispatch(resetValidationMessage());
    }, []);

    return (
        <>
            {loading && <Loader />}
            <div>
                <div className={styles.loginWrapper}>
                    <h2 className={styles.loginTitle}>Forgot Password</h2>
                    <div className={styles.loginForm}>
                        <form onSubmit={handleFotgotPassword}>
                            <div className={styles.formWrapper}>
                                <label>Email Id</label>
                                <input
                                    type="email"
                                    name="email"
                                    value={forgotDetails.email}
                                    onChange={handleForgotDetails}
                                    placeholder="Enter your email address"
                                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                                    autoFocus
                                    ref={emailRef}
                                />
                                <p className={data.statusCode === 200 ? styles.success : styles.error}>
                                    {data.statusCode === undefined ? ''
                                        :
                                        data.statusCode === 200 ? `Link has been shared with your email.`
                                            :
                                            data.statusCode === 404 && forgotDetails.email.length !== 0 ? `This email address is not registered with pineapple! Kindly enter a registered email address` : ''
                                    }
                                </p>
                                {forgotDetails.email.length === 0 && unvalid && <p className={styles.error}>email should not be empty</p>}
                            </div>
                            <div className={styles.formSubmit}>
                                <button type="submit">Continue</button>
                            </div>
                        </form>
                        <div className={styles.backSignin}>
                            <button onClick={() => navigate('/')}>Back to Login</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ForgotPassword;
